
import * as actionTypes from '../actions/actionTypes';

const initialState = {
    selectedGame: {
        id: null
    },
    selectedPattern: {
        id: null
    },
    gameList: {
        quantity: 8,
        offset: 0
    },
    reloadList: false,
    keywords_filter: [],
    game_name_filter: '',
    game_description_filter: '',
    game_types_filter: [],
    game_publishers_filter: [],
    game_developers_filter: [],
    release_start_filter: '',
    release_end_filter: '',
    authors_filter: null,
    game_style_filter: 1, // default for GamesStyle = Games
    order_by: 'game_name',
    new_game_open: false,
    gameDetailsOpen: false,
    search_panel_active: false,
    games: []
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.ADD_GAME:
            return {
                ...state,
                reloadList: true
            };
        case actionTypes.EDIT_GAME:
            return {
                ...state,
                reloadList: true
            };
        case actionTypes.CLOSE_GAME_DETAILS:
            return {
                ...state,
                // keywords_filter: [...state.keywords_filter],
                gameDetailsOpen: false,
                reloadList: true
            };
        case actionTypes.SELECT_PATTERN:
            return {
                ...state,
                gameDetailsOpen: true,
                selectedPattern: { id: action.selectedPatternId }
            };
        case actionTypes.SELECT_GAME:
            return {
                ...state,
                gameDetailsOpen: true,
                selectedGame: { id: action.selectedGameId }
            };
        case actionTypes.UPDATE_GAME_NAME_FILTER:
            return {
                ...state,
                search_panel_active: true,
                game_name_filter: action.game_name_filter,

                reloadList: true
            };
        case actionTypes.UPDATE_GAME_DESCRIPTION_FILTER:
            return {
                ...state,
                search_panel_active: true,
                game_description_filter: action.game_description_filter,

                reloadList: true
            };
        case actionTypes.UPDATE_GAME_TYPES_FILTER:
            return {
                ...state,
                search_panel_active: true,
                game_types_filter: action.game_types_filter,

                reloadList: true
            };
        case actionTypes.UPDATE_GAME_PUBLISHERS_FILTER:
            return {
                ...state,
                search_panel_active: true,
                game_publishers_filter: action.game_publishers_filter,

                reloadList: true
            };
        case actionTypes.UPDATE_GAME_DEVELOPERS_FILTER:
            return {
                ...state,
                search_panel_active: true,
                game_developers_filter: action.game_developers_filter,

                reloadList: true
            };
        case actionTypes.UPDATE_RELEASE_START_FILTER:
            return {
                ...state,
                search_panel_active: true,
                release_start_filter: action.release_start_filter,

                reloadList: true
            };
        case actionTypes.UPDATE_RELEASE_END_FILTER:
            return {
                ...state,
                search_panel_active: true,
                release_end_filter: action.release_end_filter,

                reloadList: true
            };
        case actionTypes.UPDATE_GAMES_KEYWORDS_FILTER:
            return {
                ...state,
                search_panel_active: true,
                keywords_filter: action.keywords_filter,

                reloadList: true
            };
        case actionTypes.UPDATE_GAMES_AUTHOR_FILTER:
            return {
                ...state,
                search_panel_active: true,
                authors_filter: action.author,
                order_by: 'implemented_patterns',
                reloadList: true
            }
        case actionTypes.UPDATE_GAMES_GAMES_STYLE_FILTER:
            return {
                ...state,
                search_panel_active: true,
                game_style_filter: action.game_style_id,
                reloadList: true,
            }
        case actionTypes.CLEAR_GAME_FILTERS:
            return {
                ...state,
                keywords_filter: [],
                game_name_filter: '',
                game_description_filter: '',
                game_types_filter: [],
                game_publishers_filter: [],
                game_developers_filter: [],
                release_start_filter: '',
                release_end_filter: '',
                authors_filter: null,
                game_style_filter: 1,
                order_by: 'game_name',
                reloadList: true,
            }
        case actionTypes.UPDATE_GAMES_PAGINATION:
            return {
                ...state,
                gameList: {
                    ...state.gameList,
                    offset: action.offset
                }
            };
        case actionTypes.UPDATE_GAMES_ORDER_BY:
            return {
                ...state,
                order_by: action.order_by,
                search_panel_active: true
            };
        case actionTypes.NEW_GAME_OPEN:
            return {
                ...state,
                new_game_open: true,
                selectedGame: { id: action.selectedGameId }
            };
        case actionTypes.NEW_GAME_CLOSED:
            return {
                ...state,
                new_game_open: false,
                selectedGame: { id: null }
            };
        case actionTypes.LIST_RELOADED:
            return {
                ...state,
                reloadList: false
            };
        case actionTypes.SEARCH_GAMES_TOGGLE:
            return {
                ...state,
                search_panel_active: !state.search_panel_active,
                keywords_filter: [],
                selectedGame: { id: null },
            };
        case actionTypes.AUTH_LOGOUT:
            return {
                ...state,
                search_panel_active: false,
                keywords_filter: [],
                reloadList: true,
                gameList: {
                    quantity: 8,
                    offset: 0
                },
            };
        default:
            return state;
    }
};

export default reducer;